import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField, { BaseTextFieldProps } from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

interface Props extends BaseTextFieldProps {
  gridSize: 2 | 3 | 4 | 6 | 8 | 9 | 10 | 12;
  options?: Array<{ name: string, value: string } | string>;
  onChange?: any;
  onKeyDown?: any;
  errorMessage?: string;
}

export default function GridTextField({
  inputRef,
  gridSize,
  options,
  label,
  name,
  placeholder,
  onChange,
  onKeyDown,
  errorMessage,
  disabled,
  value,
  type,
}: Props) {
  return (
    <Grid item xs={12} sm={12} md={gridSize}>
      <TextField fullWidth
        inputRef={inputRef}
        select={!!options}
        label={label}
        name={name}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        error={!!errorMessage}
        helperText={errorMessage}
        defaultValue=''
        value={value}
        disabled={disabled}
        type={type}
      >
       {options?.map(item => (
         <MenuItem
          key={typeof item === 'string' ? item : item.value}
          value={typeof item === 'string' ? item : item.value}
          children={typeof item === 'string' ? item : item.name}
        />
       ))}
      </TextField>
    </Grid>
  );
}
